/**
 * Dependencies.
 */
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

import OrderRequestMessageModel from './order-request-message.model';

/**
 * Service.
 */
class OrderRequestMessageService extends BaseService<OrderRequestMessageModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      OrderRequestMessageModel,
      OrderRequestMessageModel.name,
      applicationConstant.apiCustomerPrivateUrl
    );
  }
}

/**
 * Export `orderRequestMessageService`.
 */
export const orderRequestMessageService = new OrderRequestMessageService();
